import React from "react";
import PropTypes from "prop-types";

import "./LinkCard.scss";
import { Link } from "react-router-dom";
import SmoothScroll from "./../../utils/Helpers/SmoothScroll";

const LinkCard = ({ title, scrollTo, link }) => {

  if (!link & !scrollTo) return null

  return link ? (
    <div className="link-card">
      <Link to={link} className="btn btn-smud">
        <div>
          <p className="h6 link-text">{title}</p>
        </div>
      </Link>
    </div>
  ) : (
    <div className="link-card">
      <div className="btn btn-smud" onClick={e => SmoothScroll(scrollTo)}>
        <div>
          <p className="h6 link-text">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default LinkCard;

LinkCard.propTypes = {
  type: PropTypes.string
};
